import { CombinationFilter } from 'components/common/combination-filter-controls';
import { TonnageSeedRange } from 'features/ui/tonnage-filter-seed-types';

export const TONNAGE_FILTER_FIELD = 'tonnage';

export function tonnageSeedKeyOf(
  seed: TonnageSeedRange | null | undefined
): string | null {
  return seed ? `${seed.min}-${seed.max}` : null;
}

type TonnageRangeFilter = Extract<CombinationFilter, { kind: 'range' }>;

function findTonnageFilter(
  filters: CombinationFilter[]
): TonnageRangeFilter | undefined {
  return filters.find(
    (filter): filter is TonnageRangeFilter =>
      filter.field === TONNAGE_FILTER_FIELD && filter.kind === 'range'
  );
}

export function tonnageRangeOf(
  filters: CombinationFilter[]
): TonnageSeedRange | null {
  const found = findTonnageFilter(filters);
  if (!found) return null;
  const min = found.min ?? found.max;
  const max = found.max ?? found.min;
  if (min === undefined || max === undefined) return null;
  return { min, max };
}

export function tonnageFilterMatchesSeed(
  filters: CombinationFilter[],
  seed: TonnageSeedRange
): boolean {
  const found = findTonnageFilter(filters);
  return (
    found !== undefined && found.min === seed.min && found.max === seed.max
  );
}

export function withSeededTonnageFilter(
  filters: CombinationFilter[],
  seed: TonnageSeedRange
): CombinationFilter[] {
  return [
    ...filters.filter((filter) => filter.field !== TONNAGE_FILTER_FIELD),
    { field: TONNAGE_FILTER_FIELD, kind: 'range', min: seed.min, max: seed.max }
  ];
}

export function isTonnageSeedApplied(
  ductedFilters: { tonnageSeedKey: string | null },
  seedKey: string | null
): boolean {
  return seedKey === null || ductedFilters.tonnageSeedKey === seedKey;
}
